import { BreadcrumbHeading, Spinner } from '@weareopenr/component-library';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import styles from './MenuPublicationStatus.module.scss';

import { useMenu } from 'src/hooks/useMenu/useMenu';
import { Routes } from 'src/routes';

export const MenuPublicationStatus = () => {
  const { menuId } = useParams<{ menuId: string }>();
  const { pathname } = useLocation();
  const { data: menu, isLoading } = useMenu(menuId ?? '', { enabled: !!menuId });

  if (!menuId) {
    throw new Error('MenuPublicationStatus rendered without a menuId route param');
  }

  if (isLoading) {
    return (
      <div className={styles.spinner}>
        <Spinner size="xlarge" colour="rainbow" />
      </div>
    );
  }

  if (menu?.publication.eventId) {
    return <Navigate to={`${Routes.PUBLISH_HISTORY}/status/${menu.publication.eventId}`} replace />;
  }

  return (
    <BreadcrumbHeading
      breadcrumbs={[
        { label: 'Menus', path: Routes.MENUS },
        { label: menu?.name, path: pathname },
      ]}
      subtitle="This menu has not been published"
    />
  );
};
